import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ResponseMsg from '../general/ResponseMsg';
import '../css/components/ProductDetails.css';
import Cart from '../components/Cart.js';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import Loading from '../general/Loading';
import Default from '../assets/default.jpg';


const ProductDetails = ({ userData, isAdmin }) => {
  const [response, setResponse] = useState(null);
  const [cart, setCart] = useState([]);
  // const [showCart, setShowCart] = useState(false);
  const location = useLocation();
      const [loading, setLoading] = useState(false);
  const product = location.state?.items;
  const [selectedImage, setSelectedImage] = useState('');
  const [showUpload, setShowUpload] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [imagePreview, setImagePreview] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [error, setError] = useState('');

  const navigate = useNavigate();

  if (!product) {
    return <div>No product details available</div>;
  }

  const formatDate = (dateString) => {
    // Check if the date is null or the invalid date string "0000-00-00 00:00:00"
    if (!dateString || dateString === '0000-00-00 00:00:00') {
      return 'NA';
    }
  
    const date = new Date(dateString);
    // Check if the date is invalid after conversion
    if (isNaN(date)) {
      return 'NA';
    }
  
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };
  

  const handleAddCart = (items) => {

    if (userData.address == '') {
      setResponse('Update Address Details in your profile.');
      setTimeout(() => {
        setResponse('');
      }, 2000);
      return;
    }

    if (!items) {
      setResponse('Invalid product data');
      setTimeout(() => {
        setResponse('');
      }, 2000);
      return;
    }

    if (items.stock == 'Stock Out') {
      setResponse('This product is currently out of stock.');
      setTimeout(() => {
        setResponse('');
      }, 2000);
      return;
    }

    const existingCart = JSON.parse(localStorage.getItem('cart')) || [];
    if (!Array.isArray(existingCart)) {
      console.error('Error: existingCart is not an array');
      return;
    }

    const productIndex = existingCart.findIndex(item => item.id === items.id);

    if (productIndex === -1) {
      existingCart.push({ ...items, quantity: 1 });
    } else {
      existingCart[productIndex].quantity += 1;
    }

    localStorage.setItem('cart', JSON.stringify(existingCart));
    setCart(existingCart);
    setResponse('Product added to cart.');
    setTimeout(() => {
      setResponse('');
    }, 2000);
  };

  const productImages = product.image ? product.image.split(',') : [];
  const defaultImage = productImages[0];


  if (!selectedImage && defaultImage) {
    setSelectedImage(defaultImage);
  }

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };


  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length > 5) {
      setError('You can upload a maximum of 5 images.');
      return;
    }

    setError('');
    const imageUrls = files.map(file => URL.createObjectURL(file));
    setImagePreview(imageUrls);
    setSelectedFiles(files);
  };


  const handleSubmit = async () => {
    setLoading(true);
    const formData = new FormData();

    selectedFiles.forEach(file => {
      formData.append('images', file);
    });

    try {
      const response = await fetch(`https://api.kcmstore.in/dist/add-product-image/${product.id}`, {
        method: 'POST',
        body: formData,
      });

      setLoading(false);

      if (!response.ok) {
        throw new Error('Failed to upload images');
      }

      const data = await response.json();
      setResponse('Images Uploaded successfully!');
      setShowUpload(false);
      setTimeout(() => {
        setResponse('');
        setImagePreview([]);
        setSelectedFiles([]);
        navigate(`/inventory`);
      }, 2000);

    } catch (error) {
      setLoading(false);
      console.error('Error uploading images:', error);
    }
  };

  const handleDeleteImage = async () => {
    try {
      // Make an API call to delete the selected image
      const response = await fetch(`https://api.kcmstore.in/dist/delete-product-image/${product.id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ image: selectedImage }), // Pass the selected image to delete
      });

      if (response.ok) {
        setResponse('Image deleted successfully!');
        setShowDelete(false);
        setTimeout(() => {
          setResponse('');
          setSelectedImage(null);
          navigate(`/inventory`);
        }, 2000);
      } else {
        setResponse('Failed to delete image');
        setShowDelete(false);
        setTimeout(() => {
          setResponse('');
          setSelectedImage(null);
        }, 2000);
      }
    } catch (error) {
      console.error('Error deleting image:', error);
      setResponse('Error deleting image');
    }
  };


  return (
    <>

      <section className='px-md-3 px-sm-3 py-3'>
        <div className='profile-area-inner px-lg-5 py-lg-5 px-3 py-3 animate__animated animate__fadeInUp'>
          <p className='profile-heading'>Product Details</p>
          <hr className='profile-hr' />

          <div className="row">

            <div className="col-lg-4 col-md-5 col-5 col-12 my-2 text-center">
              <div className='product-detail-img-outer'>
                <img
                  src={selectedImage ? `https://api.kcmstore.in/uploads/${selectedImage.split(',')[0]}` : Default} 
                  alt={product.name}
                  className="product-detail-img"
                />
                {isAdmin &&
                  <span className='delete-btn' onClick={() => setShowDelete(true)}>Delete this Image <i class="fa-solid fa-xmark"></i></span>
                }
              </div>

              <Swiper spaceBetween={20} slidesPerView={3} modules={[Autoplay, Navigation]} loop={true}
                navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }} autoplay={{ delay: 2000 }}
                breakpoints={{
                  0: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  576: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                  },

                  768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  992: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  1298: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  }
                }}>

                {isAdmin &&
                  <SwiperSlide>
                    <div className='tab-image my-3 border-0 align-content-center' onClick={() => setShowUpload(true)}>
                      <span className='cursor-pointer'><i class="fa-solid fa-plus bg-dark text-white px-2 py-2 fs-5 rounded-circle"></i></span>
                    </div>
                  </SwiperSlide>
                }

                {product.image && product.image.split(',').map((image, index) => (
                  <SwiperSlide key={index}>
                    <img
                      src={`https://api.kcmstore.in/uploads/${image}`}
                      alt={`Product image ${index + 1}`}
                      className="tab-image my-3"
                      onClick={() => handleImageClick(image)}
                    />
                  </SwiperSlide>
                ))}



              </Swiper>
            </div>

            <div className="col-lg-6 col-md-7 col-7 col-12 align-content-center my-2">
              <p className='product-name mb-0'>{product.name}</p>
              <span className='fw-bold text-muted'>{product.unit}</span>

              <p className='fs-5 fw-semibold mt-3'>Product Price: <br />
                <span className='fs-4 product-price'>₹ {product.sell_price}{product.discount_amount > 0 && (
                  <span className='text-start ps-2 text-muted fw-semibold fs-6 my-0'>
                    {product.discount_type === 'amount' ? '₹' : ''}{product.discount_amount}{product.discount_type === 'percent' ? '%' : ''} Off
                  </span>
                )}</span></p>

              {!isAdmin &&
                <button className="add-btn py-2 px-3 mb-3" onClick={() => handleAddCart(product)}>Add to Cart <i class="fa-solid header-icon fa-bag-shopping"></i></button>}
              <p className='fw-semibold text-muted'>Category: {product.category || 'NA'}</p>
            </div>

          </div>
          {/* row ends */}


          <div className='row'>


            {/* {product.description ? (
              <> */}
<div className='col-lg-4 col-md-4 my-1 fw-semibold align-content-center'>Description</div>
<div className='col-lg-8 col-md-8 my-1'>
  <p className='bg-light px-3 py-3 rounded'>
    {product.mfg && (
      <>Manufactured On: {formatDate(product.mfg)}<br /></>
    )}
    {product.exp && (
      <>Expire On: {formatDate(product.exp)}<br /></>
    )}
{product.description && (
  <p dangerouslySetInnerHTML={{ __html: product.description }} />
)}
    
  </p>
</div>
              {/* </>
            ) : (
              ''
            )} */}


            {product.prescription ? (
              <>
                <div className='col-lg-4 col-md-4 my-1 fw-semibold align-content-center'>Prescription</div>
                <div className='col-lg-8 col-md-8 my-1'><p className='bg-light px-3 py-3 rounded' dangerouslySetInnerHTML={{ __html: product.prescription || 'NA' }} /></div>
              </>
            ) : (
              ''
            )}

            <div className='col-lg-4 col-md-4 my-1 fw-semibold align-content-center'>Side Effects</div>
            <div className='col-lg-8 col-md-8 my-1'><p className='bg-light px-3 py-3 rounded'>Most side effects do not
              require any medical attention and disappear as your body adjusts to the medicine. Consult your doctor if
              they persist or if you are worried about them</p></div>


          </div>
          {/* row ends */}


        </div>
      </section>

      {/* {!isAdmin &&
        <button className='cart-btn' onClick={() => setShowCart(true)}><i class="fa-solid fa-shopping-cart"></i></button>
      } */}

      {response && <ResponseMsg message={response} />}
      {/* {showCart && <Cart setShowCart={setShowCart} userData={userData} />} */}

      {showUpload && (
        <section className='detail-dialog'>
          <div className='detail-dialog-inner col-xl-4 col-lg-5 col-md-8 mx-auto px-3 py-4'>
            <p className='profile-subheading'>Upload Images</p>

            <div className='py-3'>
              <input
                type="file"
                className='bg-light px-2 py-2 col-12'
                accept="image/*"
                multiple
                onChange={handleImageChange}
              /><br />
              {error && <p className="text-danger para-text fw-semibold">{error}</p>}            </div>
            <div className="preview-images my-4">
              {imagePreview.map((image, index) => (
                <img key={index} src={image} className='col-lg-2 col-md-3 col-3' alt={`preview ${index}`} style={{ margin: '5px' }} />
              ))}
            </div>

            <button className='login-btn px-3 py-1 bg-danger' onClick={() => setShowUpload(false)}>Cancel</button>&nbsp;&nbsp;
            <button className='login-btn px-3 py-1' onClick={handleSubmit}>Submit</button>
          </div>
        </section>
      )}


      {showDelete && (
        <>
          <section className='detail-dialog'>
            <div className='detail-dialog-inner animate__animated animate__zoomIn col-lg-4 text-center col-md-8 mx-auto px-3 py-4'>
              <p className='profile-subheading'>Do you want to delete this Image?</p>
              <img
                src={`https://api.kcmstore.in/uploads/${selectedImage}`}
                alt={product.name}
                className="tab-image my-3"
              /><br />
              <button className='login-btn px-3 py-1' onClick={() => handleDeleteImage()}>Yes</button>&nbsp;&nbsp;
              <button className='login-btn px-3 py-1 bg-danger' onClick={() => setShowDelete(false)}>No</button>
            </div>
          </section>
        </>
      )}

{loading && <Loading setLoading={setLoading} />}

    </>
  );
};

export default ProductDetails;
